<template>
  <div class="right-content">
    <div class="right-content-top" >
      <div class="left-title">
        ALL
      </div>
      <div ref="topRef">
        <artmisads-select :width="200" class="country" :dropdownMatchSelectWidth="false"
        v-model:value="filter.marketplace" :getPopupContainer="() => $refs.topRef"
        @change="(value, option) => setFilter('marketplace', value)">
        <a-select-option class="country-select-item" v-for="item in Object.keys(CURRENCY_MAPPER)"
          :key="item.toLowerCase()" :value="CURRENCY_MAPPER[item].host" :currency="CURRENCY_MAPPER[item].currency">
          <svg class="icon" aria-hidden="true">
            <use :xlink:href="'#icon-guoqi-' + item.toLowerCase()"></use>
          </svg>{{ CURRENCY_MAPPER[item].host }}
        </a-select-option>
      </artmisads-select>
    </div>
   
    </div>
    <div class="mid-filter">
      <div class="mid-filter-item">
        <div class="mid-filter-title">Available Link Type</div>
        <div class="mid-filter-checkbox">
          <a-checkbox v-model:checked="query.changeAttribution">Attribution</a-checkbox>
          <a-checkbox v-model:checked="query.changeAssociate">Associate</a-checkbox>
        </div>
      </div>
      <div class="mid-filter-item">
              <span class="mid-filter-title">Starts On or After:</span>
              <a-date-picker style="width: 180px" :value="query.startAt || null" @change="onStartDateChange" />
            </div>
            <div class="mid-filter-item">
              <span class="mid-filter-title">Ends On or Before:</span>
            <a-date-picker style="width: 180px" :value="query.endAt || null" :disabled-date="disabledEndDate"
              @change="onEndDateChange" />
            </div>
    </div>
    <div class="button-groups">
      <ButtonGroups :pagination="pagination" :tableData="tableData" @pageChange="onPageChange" />
      <div class="right-buttons" ref="sortRef">
        <a-input-search allow-clear class="search" placeholder="Minimum EPC" v-model:value="filter.keyword"
          @search="(v) => setFilter('keyword', v)" />
        <artmisads-select class="width100" v-model:value="filter.sort" :getPopupContainer="() => $refs.sortRef"
          @change="(option) => setFilter('sort', option)">
          <a-select-option value="epc" style="width: 160px">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-paixu1"></use>
            </svg>
            <span style="margin-left: 4px">Earnings-per-Click  </span>
          </a-select-option>
          <a-select-option value="startDateDesc">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-paixu1"></use>
            </svg>
            <span style="margin-left: 4px">Start Date </span>
          </a-select-option>
          <a-select-option value="startDateAsc">
            <svg class="icon" aria-hidden="true" style="transform: scaleY(-1)">
              <use xlink:href="#icon-paixu1"></use>
            </svg>
            <span style="margin-left: 4px">Start Date </span>
          </a-select-option>
          <a-select-option value="endDateDesc">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-paixu1"></use>
            </svg>
            <span style="margin-left: 4px">End Date </span>
          </a-select-option>
          <a-select-option value="endDateAsc">
            <svg class="icon" aria-hidden="true" style="transform: scaleY(-1)">
              <use xlink:href="#icon-paixu1"></use>
            </svg>
            <span style="margin-left: 4px">End Date </span>
          </a-select-option>
        </artmisads-select>
      </div>
    </div>
    <div class="content-table" v-if="tableData.length > 0">
      <ContentItem v-for="item in tableData" :key="item.id" :item="item" />
        
    </div>
    <div class="empty-content" v-else>
      <a-empty />
    </div>
    
  </div>
</template>

<script setup>
import { ref, reactive,onMounted,defineProps ,watch} from 'vue'
import ButtonGroups from "@/pages/seller/Brands/components/buttonGroups.vue"
import ContentItem from './contentItem.vue'
import { cpcCampaignsApi } from '~/server'  
import { CURRENCY_MAPPER } from '~/contants/common'
import moment from 'moment'
const countryCode = localStorage.getItem('selectedSite') || 'US'
const filter = ref({
  keyword: '',
  sort: 'epc',
  marketplace: CURRENCY_MAPPER[countryCode].host,
  primaryCategoryId:"",
  brandNames:[]
})
const query = reactive({
  changeAttribution: false,
  changeAssociate: false,
  startAt:"",
endAt:''
})
const props = defineProps({
  leftFilter: {
    type: Object,
    required: true,
  },
})
watch(props.leftFilter, (newVal) => {
  if(newVal.categoryId){
    filter.value.primaryCategoryId = newVal.categoryId
  }else{
    filter.value.primaryCategoryId=""
  }
  if(newVal.selectedBrands.length > 0){
    filter.value.brandNames=[]
    newVal.selectedBrands.forEach(item => {
      filter.value.brandNames.push(item.brandName)
    })
  }else{
    filter.value.brandNames=[]
  }
  getCpcCampaigns()
})
watch(query, (newVal) => {
  pagination.current = 1
  getCpcCampaigns()
}, { deep: true })
const isEndAfterStart = (endDate, startDate) => {
  if (!endDate || !startDate) return true
  return moment(endDate).startOf("day").valueOf() > moment(startDate).startOf("day").valueOf()
}

const disabledEndDate = (current) => {
  if (!query.startAt) return false
  return !isEndAfterStart(current, query.startAt)
}

const onStartDateChange = (date) => {
  query.startAt = date || null
  if (query.startAt && query.endAt && !isEndAfterStart(query.endAt, query.startAt)) {
    query.endAt = null
  }
}

const onEndDateChange = (date) => {
  if (date && query.startAt && !isEndAfterStart(date, query.startAt)) {
    query.endAt = null
    return
  }
  query.endAt = date || null
}
const pagination = reactive({
  total: 0,
  size: 10,
  current: 1,
  pageSize: 10,
})
const tableData = ref([])

const onPageChange = (current) => {
  
  pagination.current = current
  getCpcCampaigns()
}
const getCpcCampaigns = async () => {
  const param={
    page: pagination.current,
    size: pagination.size,
   
    ...query,
    ...filter.value,
  }
  if (param.changeAttribution) {
    param.linkType = 'ATTRIBUTION'
  }
  if (param.changeAssociate) {
    param.linkType = 'ASSOCIATE'
  }
  if(param.changeAttribution && param.changeAssociate){
    param.linkType = ''
  }
  delete param.changeAttribution
  delete param.changeAssociate

  if (param.startAt) {
    param.startDateTimestamp = moment(moment(param.startAt).format('YYYY-MM-DD') + ' 00:00:00').valueOf()
  }
  if (param.endAt) {
    param.endDateTimestamp = moment(moment(param.endAt).format('YYYY-MM-DD') + ' 23:59:59').valueOf()
  }
  delete param.startAt
  delete param.endAt
  if(param.sort){
    if(param.sort === 'startDateDesc'){
      param.sortField = 'startDate'
      param.sortDirection = 'desc'
    }
    if(param.sort === 'startDateAsc'){
      param.sortField = 'startDate'
      param.sortDirection = 'asc'
    }
    if(param.sort === 'endDateDesc'){
      param.sortField = 'endDate'
      param.sortDirection = 'desc'
    }
    if(param.sort === 'endDateAsc'){
      param.sortField = 'endDate'
      param.sortDirection = 'asc'
    }
    if(param.sort === 'epc'){
      param.sortField = 'epc'
      param.sortDirection = 'desc'
    }
  }
  if(param.brandNames.length > 0){
    param.brandNames = param.brandNames.join(',')
  }
  const { data } = await cpcCampaignsApi.getCpcCampaigns(param)

 tableData.value = data.data
 pagination.total = data.total
}
onMounted(() => {
  getCpcCampaigns()
})
const setFilter = (key, value) => {
  filter.value[key] = value
  getCpcCampaigns()
}

</script>

<style scoped lang="less">
.mid-filter {
    display: flex;
    align-items: space-between;
    position: relative;
    margin-bottom: 16px;
    margin-top: 16px;
    // justify-content: space-between;
    padding: 16px;
    padding-right: 96px;
    border-radius: 8px;
    background-color: var(--bg-gray-1);
    flex-wrap: wrap;
    gap: 16px; // 垂直和水平间距都是16px
    // overflow: hidden;
    max-height: 86px; // 限制为一行的高度，不包括gap，因为第一行不会有gap
    transition: max-height 0.3s ease;

    &.expanded {
      max-height: none; // 展开时移除高度限制
      overflow: visible;
    }

    &-item {
      display: flex;
      flex-direction: column;
      // width: 20%;

      &.filter-item-hidden {
        display: none !important;
      }
    }

    //  &-item:first-child{
    //  width: 20%;
    //  }
    //  &-item:nth-child(2){
    //   width: 14%;
    //  }
    &-checkbox {
      background-color: var(--bg-gray-6);
      border-radius: 8px;
      height: 32px;
      padding: 0 8px;
      display: flex;
      align-items: center;
      // justify-content: center;
    }

    &-title {
      font-size: 13px;
      font-weight: 600;
      height: 18px;
      // opacity: 0.7;
      letter-spacing: 0.3px;
      line-height: 18px;
      color: #0f0629;
      margin-bottom: 4px;
    }
  }
.right-content {
  flex: 1;
  width: 100%;

  .right-content-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 18px 0;
    border-bottom: 1px solid rgba(232, 229, 237, 1);

    .left-title {
      font-family: Sora;
      font-weight: 600;
      font-size: 20px;
      leading-trim: NONE;
      line-height: 28px;
      letter-spacing: 0.5px;
      color: rgba(15, 6, 41, 1);
    }
  }

  .button-groups {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 0;

    .right-buttons {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }

  .content-table {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }
  .empty-content{
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 500px;
  }
}
</style>